import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BankTransactionProxyService } from '../../../proxies/bank-transaction.proxy.service';
import { BankTransaction, BankTransactionMovementType, BankTransactionStatus } from '../../../models/bank-transaction/bank-transaction';
import { EnumService } from '../../../services/enum.service';

@Component({
  selector: 'app-bank-transaction',
  templateUrl: './bank-transaction.component.html',
  styleUrl: './bank-transaction.component.scss',
})
export class BankTransactionComponent implements OnInit {
  public transactions = signal<BankTransaction[] | null>(null);
  isLoading = 0;

  private movementLabels: Record<number, string> = {};
  private statusLabels: Record<number, string> = {};
  private currencyLabels: Record<number, string> = {};

  constructor(
    private router: Router,
    private service: BankTransactionProxyService,
    private enumService: EnumService,
  ) {
    this.movementLabels = this.enumService.getEnum('BankTransactionMovementType').values as Record<number, string>;
    this.statusLabels = this.enumService.getEnum('BankTransactionStatus').values as Record<number, string>;
    this.currencyLabels = this.enumService.getEnum('Currency').values as Record<number, string>;
  }

  ngOnInit(): void {
    this.getAll();
  }

  private getAll() {
    this.isLoading++;
    this.service.getAll().subscribe({
      next: (response) => {
        if (response.data) this.transactions.set(response.data);
        this.isLoading--;
      },
      error: (error) => {
        this.isLoading--;
        throw error;
      },
    });
  }

  redirectToDetails(id?: string, type?: string) {
    const queryParams: Record<string, string> = { id: id ?? 'new' };
    if (type) queryParams['type'] = type;
    this.router.navigate(['/bank-transaction-details'], { queryParams });
  }

  speedDialItems: MenuItem[] = [
    {
      label: 'New Income',
      icon: 'pi pi-arrow-down-left',
      command: () => this.redirectToDetails('new', 'INCOME'),
    },
    {
      label: 'New Outcome',
      icon: 'pi pi-arrow-up-right',
      command: () => this.redirectToDetails('new', 'OUTCOME'),
    },
  ];

  movementLabel(type: number): string {
    return this.movementLabels[type] ?? '';
  }

  statusLabel(status: number): string {
    return this.statusLabels[status] ?? '';
  }

  currencyLabel(currency: number | undefined | null): string {
    if (currency === null || currency === undefined) return '';
    return this.currencyLabels[currency] ?? '';
  }

  movementSeverity(type: number): 'success' | 'danger' | 'info' {
    switch (type) {
      case BankTransactionMovementType.INCOME:
        return 'success';
      case BankTransactionMovementType.OUTCOME:
        return 'danger';
      default:
        return 'info';
    }
  }

  statusSeverity(status: number): 'success' | 'warn' | 'secondary' | 'info' {
    switch (status) {
      case BankTransactionStatus.POSTED:
        return 'success';
      case BankTransactionStatus.DRAFT:
        return 'warn';
      default:
        return 'info';
    }
  }
}
